// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fc-input-select .fc-input-select--selector[data-v-e60f8242] {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.fc-input-select.fc-input-select__labelled .fc-input-select--selector[data-v-e60f8242] {\n  padding-top: 1.5rem;\n  padding-bottom: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
